'use client';

import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { RxDoubleArrowDown } from 'react-icons/rx';

interface CTALinkProps {
  className?: {
    container?: string;
    icon?: string;
    title?: string;
  };
  url: string;
  title: string;
}

export function CTALink({ className, url, title }: CTALinkProps) {
  return (
    <Link
      href={url}
      prefetch={false}
      className={cn(
        'flex cursor-pointer items-center justify-start gap-2.5 text-muted-foreground transition-all hover:opacity-90',
        className?.container,
      )}
    >
      <RxDoubleArrowDown className={cn('h-5 w-5 sm:h-6 sm:w-6', className?.icon)} />
      <p className={cn('text-sm sm:text-base', className?.title)}>{title}</p>
    </Link>
  );
}
